import React, { Component } from 'react';
import { StripeProvider, Elements } from 'react-stripe-elements';
import { connect } from 'formik';

import CreditCardForm from './payment/stripe-payment.component.js';
import CheckoutService from './checkout.service.js';

import Loading from '../../components/loader/loader.component.js';
import TryAgain from '../../components/try-again/try-again.component.js';

import './payment-details.step.scss';

class PaymentDetailsStep extends Component {
	constructor(props) {
		super(props);
		this.creditCardRef = React.createRef();
		this.state = {
			stripeData: null,
			isLoading: false,
		};
	}

	componentWillMount() {
		this.getToken();
	}

	getToken() {
		const { formik: { values }, handleCard } = this.props;

		this.setState({ isLoading: true });

		let amount = values.prices.reduce(
			(accumulator, currentValue) => accumulator
				+ (currentValue.value * currentValue.quantity), 0,
		);

		amount += values.extras.reduce(
			(accumulator, currentValue) => accumulator
				+ (currentValue.price * currentValue.quantity), 0,
		);

		amount += values.selectedMethod === 'email+sms' ? 2 : 0;

		CheckoutService.getStripeToken(amount)
			.then((response) => {
				handleCard(response);
				this.setState({ isLoading: false, stripeData: response });
			})
			.catch(() => {
				this.setState({ isLoading: false });
			});
	}

	handlePayment = () => (
		this.creditCardRef.current.handlePayment()
	);

	render() {
		const {
			submitPaymentPromise, stripe, handlePayment, formik,
		} = this.props;
		const { stripeData, isLoading } = this.state;

		if (isLoading) { return (<Loading />); }

		if (!isLoading && !stripeData) {
			return <TryAgain />;
		}

		return (
			<div className="payment-details row">
				<div className="col-xs-12">
					<StripeProvider stripe={stripe}>
						<Elements>
							<CreditCardForm
								submitPaymentPromise={submitPaymentPromise}
								innerRef={this.creditCardRef}
								handlePayment={handlePayment}
								clientSecret={stripeData.clientSecret}
								isSubmitting={formik.isSubmitting}
							/>
						</Elements>
					</StripeProvider>
				</div>
			</div>
		);
	}
}


export default connect(PaymentDetailsStep);
